import styled, { css } from 'styled-components';

export const ChatBotIntroWrapper = styled.div`
  ${({ showIntro, theme }) => css`
    background: linear-gradient(180deg, #3B457E 0%, #1681DF 100%);
    border-radius: 16px;
    bottom: 183px;
    box-shadow: 0px 20px 30px 0px rgba(36, 36, 36, 0.15);
    font-family: ${theme.v2.font.family.primary};
    height: 700px;
    padding: 24px;
    position: fixed;
    right: 17px;
    width: 332px;
    z-index: 1001;

    opacity: ${showIntro ? 1 : 0};
    transition: all 0.3s ease-in-out;

    @media (max-width: ${({ theme }) => theme.v2.breakpoints.md}) {
      border-radius: 0;
      height: 100%;
      left: 0;
      padding: 20px;
      right: 0;
      top: 0;
      width: 100%;
    }

    @media (max-height: 800px) {
      height: 542px;
    }
  `}
`;

export const ChatBotIntroduction = styled.div`
  padding-top: 86px;
  position: relative;

  @media (max-height: 800px) {
    padding-top: 40px;
  }
`;

export const IconCloseWrapper = styled.div`
  position: absolute;
  right: -8px;
  top: -3px;

  @media (max-width: ${({ theme }) => theme.v2.breakpoints.md}) {
    right: -11px;
    top: -6px;
  }
`;

export const Title = styled.h3`
 ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.highPure};
    font-family: ${({ theme }) => theme.v2.font.family.primary};
    font-size: 28px;
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
  `}    
`;

export const IconWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  margin-bottom: 3px;
`;

export const Description = styled.p`
 ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.highPure};
    font-family: ${({ theme }) => theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin-top: 24px;
  `}    
`;

export const Card = styled.div`
 ${({ theme }) => css`
    align-items: center;
    background: rgba(62, 137, 203, 0.24);
    border-radius: 8px;
    color: ${theme.v2.colors.neutral.highPure};
    display: flex;
    font-family: ${({ theme }) => theme.v2.font.family.primary};
    font-size: 16px;
    font-weight: ${theme.v2.font.weights.light};
    gap: 12px;
    line-height: 21px;
    margin-top: 8px;
    padding: 16px;
  `}    
`;

export const CardText = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.highPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
  `}
`;

export const IconCheckWrapper = styled.div`
  align-items: center;
  background: rgba(255, 255, 255, 0.20);
  border-radius: 50%;
  display: flex;
  height: 20px;
  min-height: 20px;
  justify-content: center;
  width: 20px;
  min-width: 20px;
`;

export const BetaLabel = styled.span`
 ${({ theme, small }) => css`
    align-items: center;
    background: rgba(255, 255, 255, 0.12);
    border-radius: 4px;
    color: ${theme.v2.colors.neutral.highPure};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.medium};
    justify-content: center;
    padding: ${small ? '2px 4px' : '2px 0px 3px 0px'};
    width: ${small ? '35px' : '42px'};
  `}    
`;

export const ButtonWrapper = styled.div`
  margin-top: 32px;
`;

export const ErrorButtonWrapper = styled.div`
  ${({ theme, isErrorRetry }) => css`
    button {
      background-color: ${isErrorRetry && theme.v2.colors.brand.primaryLowLight}
    }
  `}
`;

export const ChatWindow = styled.div`${({
  showChat, theme, chatbotMinimized, openingChat, transitionToWidget, isOnboarding, isMobile,
}) => {
  let bottomValue = '112px';
  if (openingChat) bottomValue = '87px';

  const height = '100% - 52px - 40px';
  let maxHeight = `calc(${height})`;

  if (isOnboarding) {
    bottomValue = isMobile ? '233px' : '183px';
    maxHeight = isMobile ? `calc(${height} - 145px)` : `calc(${height} - 105px)`;
  }

  return css`
    background: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
    bottom: ${bottomValue};
    box-shadow: 0px 20px 30px 0px rgba(36, 36, 36, 0.15);
    display: flex;
    flex-direction: column;
    height: ${chatbotMinimized ? '0px' : '100%'};
    justify-content: space-between;
    overflow: hidden;
    position: fixed;
    right: 16px;
    width: ${chatbotMinimized ? '0px' : '380px'};
    z-index: ${openingChat ? '1000000' : '1001'};
    opacity: ${showChat && !transitionToWidget && !chatbotMinimized ? 1 : 0};
    transition: all 0.2s ease-in-out;
    max-height: ${maxHeight};
    
    @media (max-width: ${({ theme }) => theme.v2.breakpoints.md}) {
      border-radius: 0;

      right: 0;
      left: 0;
      top: 0;
      width: 100%;
    }
  `;
}}`;

export const ChatHeader = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.v2.colors.brand.menuPrimaryDark};
  border-radius: 16px 16px 0 0;
  display: flex;
  height: 64px;
  min-height: 64px;
  justify-content: space-between;
  padding: 0px 24px;

  @media (max-width: ${({ theme }) => theme.v2.breakpoints.md}) {
    border-radius: 0;
  }
`;

export const ChatHeaderTitle = styled.h3`
 ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.neutral.highPure};
    display: flex;
    gap: 8px;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: 24px;
    margin: 0;
  `}    
`;

export const ChatHeaderActions = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  padding-top: 2px;
`;

export const ChatBody = styled.div`
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  height: 526px;
  padding: 16px;
  padding-right: 4px;

  @media (max-height: 800px) {
      height: 372px;
    }
`;

export const ChatMessages = styled.div`
  ${({ theme, hideScrollbar }) => css`
    display: flex;
    flex-direction: column;
    height: 99%;
    overflow-y: ${hideScrollbar ? 'hidden' : 'scroll'};
    padding-right: 12px;

    & > :first-child {
      margin-top: auto;
    }

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: ${theme.v2.colors.neutral.highPure};
    }

    &::-webkit-scrollbar-thumb {
      background: ${theme.v2.colors.neutral.highMedium};
      cursor: pointer;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${theme.v2.colors.neutral.highMedium};
    }

  `}
`;

export const ChatMessageWrapper = styled.div`
  ${({ fromUser }) => css`
    align-items: flex-end;
    display: flex;
    gap: 4px;
    justify-content: ${fromUser ? 'flex-end' : 'flex-start'};
    margin-top: 16px;
  `}    
`;

export const IconStarsMessage = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.v2.colors.brand.primaryMedium};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  padding: 8px;

  svg {
    height: 12px;
    width: 12px;
  }

`;

export const ChatMessage = styled.div`
 ${({ theme, fromUser }) => css`
    background: ${fromUser ? theme.v2.colors.brand.primaryMedium : theme.v2.colors.brand.primaryLowLight};
    border-radius: 16px;
    color: ${fromUser ? theme.v2.colors.neutral.highPure : theme.v2.colors.neutral.lowPure};
    display: flex;
    flex-direction: column;
    gap: 13px;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    max-width: ${fromUser ? '80%' : '70%'};
    padding: 16px;
    word-break: break-word;
  `}    
`;

export const ChatFooter = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.v2.colors.neutral.highPure};
  border-radius: 0 0 16px 16px;
  display: flex;
  flex-direction: column;
  padding: 0px 16px;

  @media (max-width: ${({ theme }) => theme.v2.breakpoints.md}) {
    border-radius: 0;
  }
`;

export const ChatInput = styled.input`
  ${({ theme }) => css`
    background: ${theme.v2.colors.neutral.highPure};
    border: none;
    border-radius: 50px;
    color: ${theme.v2.colors.neutral.high};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    height: 30px;
    margin: 13px;
    outline: none;
    width: 100%;

    &::placeholder {
      color: ${theme.v2.colors.neutral.lowMedium};
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xxs};
      font-weight: ${theme.v2.font.weights.regular};
    }

    &:focus {
      outline: none;
    }
    
  `}    
`;

export const Icon = styled.img`
  &:hover {
    filter: brightness(0.7);
  }
`;

export const ChatInputWrapper = styled.div`
 ${({ theme }) => css`
    align-items: center;
    border-radius: 50px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    display: flex;
    gap: 8px;
    height: 40px;
    margin-top: 8px;
    width: 100%;

    button {
      border-radius: 50%;
      height: 36px;
      margin: 9px;
      width: 36px;
      
      &:hover {
        background: ${theme.v2.colors.neutral.highLight};
      }

      &:focus {    
        background: ${theme.v2.colors.neutral.highLight};
        outline: none;
      }
    }
  `}    
`;

export const AlertMessage = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.medium};
    padding: 4px 8px;
  `} 
`;

export const ModalWrapper = styled.div`
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 16px;
  display: flex;
  height: 100%;
  justify-content: center;
  max-height: 700px;
  max-width: 380px;
  position: fixed;
  width: 100%;
  z-index: 1002;
`;

export const Modal = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v2.colors.neutral.highPure};
    border-radius: 8px;
    color: ${theme.v2.colors.neutral.lowMedium};
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin: 10px;
    padding: 63px 20px 31px 20px;
    position: relative;
    width: 360px;
  `}    
`;

export const ModalCloseWrapper = styled.div`
  cursor: pointer;
  position: absolute;
  right: 13px;
  top: 18px;
`;

export const ModalTitle = styled.h3`
 ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 21px;
    margin: 0;
  `}    
`;

export const ModalAlert = styled.p`
 ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 21px;
    margin: 0;
    margin-top: 3px;
    text-align: center;
    width: 250px;
  `}    
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 17px;
`;

export const Dot = styled.span`
  ${({ theme }) => css`
    width: 6px;
    height: 6px;
    margin: 0 2px;
    background-color: ${theme.v2.colors.neutral.lowPure};
    border-radius: 50%;
    display: inline-block;
    animation: typing 1.5s infinite;

    @keyframes typing {
      0% {
        opacity: 0.2;
        transform: translateY(0);
      }
      20% {
        opacity: 1;
        transform: translateY(-5px);
      }
      50% {
        opacity: 0.2;
        transform: translateY(0);
      }
      100% {
        opacity: 0.2;
        transform: translateY(0);
      }
    }
  `}
`;

export const TypingDots = styled.div`
  align-items: center;
  display: flex;
  gap: 4px;
  height: 20px;
  justify-content: center;

  span:nth-child(2) {
    animation-delay: 0.3s;
  }

  span:nth-child(3) {
    animation-delay: 0.6s;
  }
`;

export const FeedbackWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  width: 100%;
`;

export const FeedbackButton = styled.button`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v2.colors.brand.primaryUltraLight};
    border-radius: 50%;
    border: none;
    cursor: pointer;
    display: flex;
    height: 32px;
    justify-content: center;
    width: 32px;
  `}    
`;

export const ChatEnd = styled.div``;


export const ChatButtonContainer = styled.div`${({
  openingChat, isOnboarding, isMobile,
}) => {
  let bottomValue = '44px';

  if (isOnboarding) {
    bottomValue = isMobile ? '165px' : '115px';
  }

  return css`
    bottom: ${bottomValue};
    opacity: ${openingChat ? 0 : 1};
    position: fixed;
    right: 16px;
    z-index: 1000;
  `;
}}`;

export const BotMessage = styled.div``;
